import MyTicketsPage from "./pages/MyTicketsPage";
import CreateTicketPage from "./pages/CreateTicketPage";
import TicketDetailPage from "./pages/TicketDetailPage";
import AdminTicketsPage from "./pages/AdminTicketsPage";
import AdminTicketDetailPage from "./pages/AdminTicketDetailPage";
import AdminCategoriesPage from "./pages/AdminCategoriesPage";

const MEMBER_ROLES = [
  "member",
  "executive",
  "chairman",
  "secretary",
  "fellow",
  "firm",
  "past president",
  "probationer",
  "assessor",
  "student",
  "technician",
];

export const supportRoutes = [
  // Member
  { path: "/support/tickets",        element: <MyTicketsPage />,          roles: [...MEMBER_ROLES, "admin"] },
  { path: "/support/tickets/new",    element: <CreateTicketPage />,       roles: [...MEMBER_ROLES, "admin"] },
  { path: "/support/tickets/:id",    element: <TicketDetailPage />,       roles: [...MEMBER_ROLES, "admin"] },

  // Admin
  { path: "/admin/support/tickets",        element: <AdminTicketsPage />,       roles: ["admin"] },
  { path: "/admin/support/tickets/:id",    element: <AdminTicketDetailPage />,  roles: ["admin"] },
  { path: "/admin/support/categories",     element: <AdminCategoriesPage />,    roles: ["admin"] },
];
